import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/@core/services/notification.service';
import { EnterpriseAdminService } from '../../../enterprise-admin.service';
import { AppService } from 'src/@core/services/app.service';

@Component({
  selector: 'hour4u-admin-add-vendor',
  templateUrl: './add-vendor.component.html',
  styleUrls: ['./add-vendor.component.scss']
})
export class AddVendorComponent implements OnInit {
  createVendorForm: FormGroup;
  submitted = false;
  profile = this.appService.getCurrentAccount();

  constructor(
    public dialogRef: MatDialogRef<AddVendorComponent>,
    private _fb: FormBuilder,
    private notify: NotificationService,
    private enterpriseAdminService: EnterpriseAdminService,
    private appService: AppService
  ) { }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.createVendorForm = this._fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      contact_person: [''],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.pattern('^[5-9][0-9]{9}$'), Validators.minLength(10), Validators.maxLength(10)]],
      point_of_contact: [''],
      company_logo: [''],
      company_name: [''],
      company_address: [''],
      company_gst: [''],
      company_pan: [''],
      // Add more form controls as needed
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave(): void {
    this.submitted = true;

    if (this.createVendorForm.invalid) {
      this.createVendorForm.markAllAsTouched();
      this.submitted = false;
      return;
    } else {
      this.addVendor();
    }
  }

  addVendor(): void {
    const entityId = this.profile.entity.id;
    console.log(entityId, 'entityId');
    const vendorData = {
      name: this.createVendorForm.value.name,
      mobile: this.createVendorForm.value.mobile,
      email: this.createVendorForm.value.email,
      // Add more fields if needed
      entityType: 'VENDOR'
    };

    this.enterpriseAdminService.addVendor(entityId, vendorData)
      .subscribe((res: any) => {
        this.notify.showMessage('Vendor Added Successfully!', 3000);
        this.dialogRef.close(res);
      }, err => {
        console.error('Error adding vendor:', err);
        this.submitted = false;
        this.notify.error('Failed to add vendor. Please try again.');
      });
  }

}
